/* Product Showcase — horizontal scroll arrows (desktop only). */

(function () {
  'use strict';

  function init(wrap) {
    const grid = wrap.querySelector('.product-showcase__grid');
    const prev = wrap.querySelector('.product-showcase__arrow--prev');
    const next = wrap.querySelector('.product-showcase__arrow--next');
    if (!grid || (!prev && !next)) return;

    function step() {
      const card = grid.querySelector('.product-showcase__item');
      const gap = parseFloat(getComputedStyle(grid).gap) || 0;
      const cardW = card ? card.getBoundingClientRect().width : 300;
      return cardW + gap;
    }

    function updateVisibility() {
      const maxScroll = grid.scrollWidth - grid.clientWidth - 1;
      if (prev) prev.toggleAttribute('hidden', grid.scrollLeft <= 0);
      if (next) next.toggleAttribute('hidden', grid.scrollLeft >= maxScroll);
    }

    if (prev) prev.addEventListener('click', () => {
      grid.scrollBy({ left: -step(), behavior: 'smooth' });
    });
    if (next) next.addEventListener('click', () => {
      grid.scrollBy({ left: step(), behavior: 'smooth' });
    });

    grid.addEventListener('scroll', updateVisibility, { passive: true });
    window.addEventListener('resize', updateVisibility);
    updateVisibility();
  }

  function boot() {
    document.querySelectorAll('.product-showcase__scroll-wrap').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
